import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { Edit_setting, Get_Settings_byid } from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import LoadingSpinner from "views/Components/loadingSpinner";
import ProcessingLoader from "views/Components/processingLoader";
class editsetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setting_value: "",
      setting_label: "",
      setting_valueError: null,
      setting_labelError: null,
      processing: true,
      settingsloading: false,
      processingLoader: false,
      _notificationSystem: null,
      errormessages: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.item_code_error = React.createRef();
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    this.setState({ settingsloading: true }, () => {
      var id = JSON.parse(localStorage.getItem("settingid"));
      Get_Settings_byid(id, obj).then((res) => {
        console.log(res);
        if (res.data.success == true) {
          var com = res.data.data;
          this.setState({
            setting_label: com.setting_label,
            setting_value: com.setting_value,
          });
          this.setState({ settingsloading: false });
        }
      });
    });
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Setting</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.setting_label.length == 0) {
      error = true;
      this.setState({
        setting_labelError: (
          <small className="text-danger">Label is required.</small>
        ),
      });
    } else {
      this.setState({ setting_labelError: null });
    }
    if (this.state.setting_value.length == 0) {
      error = true;
      this.setState({
        setting_valueError: (
          <small className="text-danger">value is required.</small>
        ),
      });
    } else {
      this.setState({ setting_valueError: null });
    }
    if (!error) {
      var id = JSON.parse(localStorage.getItem("settingid"));

      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({ processingLoader: true }, () => {
        Edit_setting(
          this.state.setting_label,
          this.state.setting_value,
          id,
          obj
        )
          .then((res) => {
            if (res.data.success === false) {
              this.handleClick("bl");
            } else if (res.data.success === true) {
              this.setState({ processingLoader: false });

              this.handleSuccess("bl");
            }
          })
          .catch((error) => {
            console.log(error, "== error");
            this.handleNetworkError("bl");
          });
      });
    }
  };

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          {this.state.settingsloading ? <LoadingSpinner /> : ""}
          {this.state.processingLoader ? <ProcessingLoader /> : ""}
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <FormGroup>
                      <ControlLabel>Commision</ControlLabel>
                      <FormControl
                        disabled={
                          this.state.settingsloading == false ? "" : "disabled"
                        }
                        name="setting_label"
                        value={this.state.setting_label}
                        onChange={(event) => {
                          this.setState({ setting_label: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                setting_labelError: (
                                  <small className="text-danger">
                                    Label is required.
                                  </small>
                                ),
                              })
                            : this.setState({ setting_labelError: null });
                        }}
                        placeholder="Enter Lable"
                        style={{ width: "200px" }}
                        type="text"
                      />
                      {this.state.setting_labelError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Value</ControlLabel>

                      <FormControl
                        disabled={
                          this.state.settingsloading == false ? "" : "disabled"
                        }
                        name="setting_value"
                        onWheel={(e) => e.target.blur()}
                        value={this.state.setting_value}
                        onChange={(event) => {
                          this.setState({ setting_value: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                setting_valueError: (
                                  <small className="text-danger">
                                    value is required.
                                  </small>
                                ),
                              })
                            : this.setState({ setting_valueError: null });
                        }}
                        placeholder="Enter Value"
                        style={{ width: "200px" }}
                        // {this.state.setting_label == "medicine_order_without_inventory" ? "" : min={0} }
                        type={
                          this.state.setting_label ==
                            "Medicine Order Without Inventory" ||
                          this.state.setting_label ==
                            "Lab Order Without Inventory" ||
                          this.state.setting_label == "Multiple Pharmacy"
                            ? "text"
                            : "number"
                        }
                      />
                      {this.state.setting_valueError}
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      disabled={this.state.processingLoader}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editsetting;
